<template>
  <div>
    <transition name="fade">
      <div class="zoom-lightbox" v-show="visible" v-on:click="handleLbClose">
        <div class="style-popup-holder" ref="zholder">
          <div class="style-popup" :class="{animation: animation}">
            <div class="close-box" v-on:click="handleClose"></div>
            <div class="style-pop-browse">
              <div class="top-area">
                <img :src="logo.logo" width="225" :alt="logo.alt" />
              </div>
              <div class="flex-top">
                <div class="browse-col">
                  <div class="style-head">
                    {{ $nippets.styles}} &nbsp;<span class="gr">/</span>&nbsp;
                    <span class="lc">{{ $nippets.categories}}</span>&nbsp;
                    <span class="gr">/</span>&nbsp; <span class="lc">{{ $nippets.media }}</span></div>
                  <div class="three-col">
                    <ix-router-link v-for="gal in gals" :key="gal.gallery_id" :to="gal.url" v-on:click.native="goTo(gal.url)" v-html="gal.name"></ix-router-link>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import logos from './logos.js'
import StyleFetcher from '@/mixins/StyleFetcher.js'

export default {
  mixins: [StyleFetcher],
  props: {
    visible: Boolean,
  },
  computed: {
    logo () {
      if(this.animation) {
        return logos.anim
      }
      return logos.illus
    }
  },
  created () {
    this.init()
  },
  methods: {
    goTo: function (url) {
      this.$ixr.push(url)
      this.handleClose()
    },
    handleClose: function () {
      this.$emit('close')
    },
    handleLbClose: function (e) {
      if(this.$refs.zholder.contains(e.target)){
        return
      }
      this.handleClose()
    }
  }
}
</script>

<style scoped>
.style-popup-holder{
  position:fixed;
  width:100%;
  z-index:500;
  box-sizing:border-box;
  left:0;
  top:110px;
  transition:all 0.2s ease;
  cursor:auto;
}

.scrolled .style-popup-holder{
  top:58px;
}

.flex-top{
  display:flex;
  align-items:flex-start;
  justify-content: flex-start;
  min-height:400px;
}

.extra-cols{
  display:flex;
}

.browse-col{
  margin-right:5vw;
}

.gr{
  color:#999;
  font-weight:300;
}

.style-popup{
  background-color:#fff;
  box-sizing:border-box;
  min-height:100px;
  max-width:1750px;
  position:relative;
  margin-left:auto;
  margin-right:auto;
  max-height:80vh;
  overflow-y:auto;
}

.style-pop-browse{
  padding:45px;
}

.style-head{
  color:#ce0e2d;
  font-size:32px;
  font-weight:500;
  margin: 20px 0;
}


.style-popup .three-col{
  columns:5;
  text-align:center;
  padding:10px 0;
}

.style-popup.animation .three-col{
  columns:2;
}

.flex-top .browse-col a{
  display:block;
  margin-bottom:1em;
  color:#000;
}

.flex-top .browse-col a.router-link-exact-active{
  color:#ce0e2d;
  font-weight:500;
}

.flex-top .browse-col a:hover{
  color:#ce0e2d;
}

.top-area{
  margin-right:10vw;
}

.lc{
  text-transform: lowercase;
}

@media screen and (max-width:1024px){
  .top-area{
    display:none;
  }
}

@media screen and (max-width:768px){
  .style-popup .three-col{
    columns:3;
  }
  .style-popup-holder{
    top:0;
  }

  .flex-top{
    display:block;
  }
}

@media screen and (max-width:640px){
  .style-popup .three-col{
    columns:2;
  }
}
</style>
